/* eslint-disable func-names */
/* eslint-disable class-methods-use-this */
import React from 'react';
import Loadable from 'react-loadable';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Cookie from 'utils/cookies';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import {
  isPrimeUser,
  enableBodyScroll,
  disableBodyScroll,
  getDomainOnly,
} from '../../utils/common';

//import s from './PrimeWelcomePopup.scss';
import {
  CONGRATS_POPUP_STORAGE_NAME,
  PRC_FOR_SUBSCRIBED,
} from '../../constants';

const LoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'PrimeWelcomePopLoader' */ './PrimeWelcomePopup'),
  loading: () => null,
  // timeout: 50000,
});

class PrimeWelcomePopupLoader extends React.Component {
  constructor() {
    super();
    this.state = {
      showPrimeWelcome: false,
    };
    //this.congratsPopupStorageName = 'congrats_popup';
  }

  componentDidMount() {
    //this.initPrimeCongrats();
    window.addEventListener(
      'primewelcomepopup',
      this.getPrimeCongratsPopup,
      false,
    );
  }

  closePrimeWelcomePopUpHandler = () => {
    localStorage.setItem(CONGRATS_POPUP_STORAGE_NAME, '1');
    this.setState({ showPrimeWelcome: false });
    enableBodyScroll();
    if (this.isReloadRequired) {
      this.deleteiprCookie();
      window.location.reload(true);
    }
  };

  deleteiprCookie = () => {
    const domain = getDomainOnly();
    Cookie.remove('ipr', '/', domain);
  };

  fireGASubscription = () => {
    const data = {};
    data.gaAction = `unknownsource|Conversion`;
    data.gaLabel = `success-${PRC_FOR_SUBSCRIBED}`;
    sendGaThroughProps({ data });
  };

  showPrimeWelcomePopup = () => {
    if (typeof window === 'undefined') {
      return;
    }
    const _isPrimeUser = isPrimeUser();
    if (_isPrimeUser && this.props.userData && this.props.userData.isLoggedIn) {
      if (typeof localStorage === 'object') {
        try {
          const congratsPopUp = localStorage.getItem(
            CONGRATS_POPUP_STORAGE_NAME,
          );
          // show prime pop up if congrats_popup value is 1
          if (congratsPopUp !== '1' && this.popUpCallbacks) {
            this.popUpCallbacks.onReadyCallback(1);
          }
        } catch (e) {
          console.log('local storage not available');
        }
      }
    }
  };

  renderPrimeWelcomePopup = () => {
    if (this.popUpCallbacks) {
      this.popUpCallbacks.onShowCallback(true);
    }
    this.setState({ showPrimeWelcome: true });
    disableBodyScroll();
  };

  initPrimeCongrats = () => {
    if (typeof window === 'undefined') {
      return;
    }
    this.bindEvents();
  };

  getPrimeCongratsPopup = event => {
    const _isPrimeUser = isPrimeUser();
    const showForce = event.showForce || false;
    this.isReloadRequired = event.isReloadRequired || false;
    if (_isPrimeUser && this.props.userData) {
      if (typeof localStorage === 'object') {
        try {
          const congratsPopUp = localStorage.getItem(
            CONGRATS_POPUP_STORAGE_NAME,
          );
          // show prime pop up if congrats_popup value is 1
          if (congratsPopUp !== '1' || !!showForce) {
            this.renderPrimeWelcomePopup();
            this.fireGASubscription();
          }
        } catch (e) {
          console.log('local storage not available');
        }
      }
    }
  };

  render() {
    if (this.props.forceHide === true) return null;
    if (this.state.showPrimeWelcome) {
      return (
        <LoadableComponent
          {...this.props}
          closePrimeIntroPopup={this.closePrimeWelcomePopUpHandler}
        />
      );
    }
    return null;
  }
}

const mapStateToProps = state => ({
  userData: state.login.userData,
  forceHide: state.commonPopUpManager && state.commonPopUpManager.forceHide,
});

PrimeWelcomePopupLoader.propTypes = {
  userData: PropTypes.shape({ isLoggedIn: PropTypes.bool }),
  //isWapView: PropTypes.bool,
  forceHide: PropTypes.bool,
};

PrimeWelcomePopupLoader.defaultProps = {
  userData: {},
  //isWapView: false,
  forceHide: false,
};

export default connect(mapStateToProps)(PrimeWelcomePopupLoader);
